export default "\n@export clay.compositor.vertex\nuniform mat4 worldViewProjection : WORLDVIEWPROJECTION;\nattribute vec3 position : POSITION;\nattribute vec2 texcoord : TEXCOORD_0;\nvarying vec2 v_Texcoord;\nvoid main()\n{\n v_Texcoord = texcoord;\n gl_Position = worldViewProjection * vec4(position, 1.0);\n}\n@end";



//////////////////
// WEBPACK FOOTER
// ./node_modules/.store/claygl@1.3.0/node_modules/claygl/src/shader/source/compositor/vertex.glsl.js
// module id = null
// module chunks = 